import FIELDS from '@enums/contextFields';
import AppState from '@models/appState';
import queryString from 'query-string';

const queries = queryString.parse(location.search);

const InitialAppContext: AppState = {
  [FIELDS.POSTCODE]: String(queries.postcode ?? ''),
  [FIELDS.QUOTE_ID]: String(queries.quoteId ?? '')
};

export default InitialAppContext;
